import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { Status } from '../../classess/status/status';
import { getProcessButtons, isUndNullEmp, getResponse, handleResponseMessageAsync, settings, styles } from '../../helpers/main';
import { StatusService } from '../../services/status/StatusService';
const { html, icons, images, labels, messages, } = settings;

// const currentMethod = 'StatusAddEditDetails';

export default function StatusAddEditDetails({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageId: 'en',
        dtStatusId: '',
        dtStatusRowId: 0,
    },
    setModalObj = {},
    status = Status?.getClass({}, false),
    setStatus = {},
}) {
    //#region variables
    const [process, setProcess] = useState({
        save: false,
    });
    const [nameError, setNameError] = useState('');
    const [dataFormLength] = useState(Status.minMaxLength(false));
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
            closeModal: {
                defaultClass: 'close btn-danger fas fa-window-close',
                id: 'btnModalClose',
            },
        },
        icons: {
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            secondaryId: {
                id: 'inputSecondaryId',
            },
            name: {
                id: 'inputName',
            },
        },
        spiners: {
            save: {
                id: 'spSave',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region status
    const addStatus = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'addStatus';
        try {
            if (e && e.preventDefault) e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true }));

            //#region status (create)
            response = await StatusService.create({
                auth: modalObj?.auth,
                data: status,
                languageId: modalObj?.languageId,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const statusResult = Status?.getClass(response?.result.status, false);
            //#endregion status (create)

            //#region datatable add
            const processButtons = [];
            modalObj.$(`#${modalObj.dtStatusId}`).DataTable().row.add([
                statusResult.name,
                getProcessButtons({
                    id: statusResult.id,
                    description: statusResult.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageId],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageId],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageId],
                    enabledEdit: true,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable add

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageId]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageId
                });
            }
        }
    }

    const editStatus = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'editStatus';
        try {
            if (e && e.preventDefault) e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true }));

            //#region status (update)
            response = await StatusService.update({
                auth: modalObj?.auth,
                id: status?.id,
                data: status,
                languageId: modalObj?.languageId,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const statusResult = Status?.getClass(response?.result?.status, false);
            //#endregion status (update)

            //#region datatable update
            const processButtons = [];
            modalObj.$(`#${modalObj.dtStatusId}`).DataTable().row(modalObj.dtStatusRowId).data([
                statusResult.name,
                getProcessButtons({
                    id: statusResult.id,
                    description: statusResult.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageId],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageId],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageId],
                    enabledEdit: true,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable update

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageId]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageId
                });
            }
        }
    }
    //#endregion status

    //#region helpers
    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setNameError('');
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            if (isUndNullEmp({ data: status?.name, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                setNameError(`${messages?.thisFieldRequired?.[modalObj?.languageId]}.`);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion helpers

    //#region effects
    useEffect(() => {
    }, []);
    //#endregion effects
    //#endregion methods

    //#region render
    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='status' src={images?.icons?.status} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.status?.[modalObj?.languageId]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={html?.badges?.micro}>
                                <i className={`${modalObj?.type === 0 ? icons?.fasFa?.plus : modalObj?.type === 1 ? icons?.fasFa?.edit : icons?.fasFa?.infoCircle} mr-1`} />
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageId] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageId] :
                                        labels?.detail?.[modalObj?.languageId]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    type='button'
                    className='close border-0 bg-transparent'
                    disabled={process?.save}
                    data-dismiss='modal'
                    aria-label='Close'
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.closeModal?.id })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header >
            <form onSubmit={(e) => modalObj?.type === 0 ? addStatus({ e }) : editStatus({ e })}>
                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div className='row'>
                                <div className='col-12 col-md-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageId]}
                                        </small>
                                        <input id={controls?.inputs?.name?.id}
                                            className='form-control bg-light border-0 shadow-sm'
                                            readOnly={process?.save}
                                            maxLength={dataFormLength?.max?.name}
                                            onChange={(e) => setStatus(prev => ({ ...prev, name: e?.target?.value }))}
                                            onFocus={() => setNameError('')}
                                            value={status?.name || ''}
                                            placeholder={labels?.name?.[modalObj?.languageId]}
                                            title={labels?.name?.[modalObj?.languageId]}
                                            style={{ borderRadius: '5px' }} />
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(nameError)}</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='row'>
                                {/* Details View Premium */}
                                <div className='col-12 col-md-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageId]}
                                        </small>
                                        <div className='h5 mb-0 font-weight-bold text-dark' style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                                            {status?.name || '---'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.defaultClass}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            tooltip='tooltip'
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageId] : labels?.save?.[modalObj?.languageId]}
                            type='submit'
                            style={{ borderRadius: '5px' }}>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.defaultClass} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageId] : labels?.save?.[modalObj?.languageId]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.defaultClass}
                            disabled={process?.save}
                            tooltip='tooltip'
                            title={labels?.close?.[modalObj?.languageId]}
                            type='button'
                            style={{ borderRadius: '5px' }}
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass} /> {labels?.back?.[modalObj?.languageId]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal >
    )
    //#endregion render
}